import { captureException } from '@sentry/capacitor'
import initLogger from '@gifsa/logger'

export type Logger = Pick<
  ReturnType<typeof initLogger>['logger'],
  'debug' | 'info' | 'warn' | 'error'
>

export function useLogger(name: string): Logger {
  const { logger } = initLogger(name)
  return {
    debug: logger.debug.bind(logger),
    info: logger.info.bind(logger),
    warn: logger.warn.bind(logger),
    error: <T extends object>(obj: Error | (T & { error?: Error }), message?: string) => {
      logger.error(obj, message)
      if (import.meta.client) {
        if (typeof obj === 'string') {
          captureException(new Error(obj), { extra: { message } })
          return
        }
        if (obj instanceof Error) {
          captureException(obj, { extra: { message } })
          return
        }
        if ('error' in obj && obj.error instanceof Error) {
          const { error, ...rest } = obj
          captureException(error, { extra: { message, ...rest } })
          return
        }
        if (message) {
          captureException(new Error(message), {
            extra: { data: JSON.stringify(obj) },
          })
          return
        }
        captureException(new Error(JSON.stringify(obj)))
      }
    },
  }
}
